/**
 * Created by heshufen on 18/12/19.
 */

import React from 'react';
import {Horizontal, Image, Text, Vertical} from "../../../components/index";


const screenWidth = window.screen.width;

const pageMargin = 15;
const feedImgDivider = 3;
const feedImgLen1 = screenWidth - pageMargin * 2;
const feedImgLen2 = parseInt(screenWidth - pageMargin * 2 - feedImgDivider) / 2;
const feedImgLen3 = parseInt(screenWidth - pageMargin * 2 - feedImgDivider * 2) / 3;

const feedImgLen4 = parseInt(screenWidth - pageMargin * 2 - feedImgDivider - feedImgLen3);

export default class ImagesGrid extends React.Component {

    shouldComponentUpdate(nextProps, nextState) {

        return nextProps.images !== this.props.images
    }

    _onImagePress = (index) => {

        // this.props.navigation.push('PicturesBrowser', {imageUrls: JSON.stringify(images), index, _id});
    };

    render() {
        let {images } = this.props;

        // if (!isFromFlatView && images.length > 4) {
        //
        // }

        if (images.length == 1) {

            let url = images[0];
            let arr1 = url.split('_W_');

            let imageW;
            let imageH;

            if (arr1.length === 2) {
                let arr2 = arr1[1].split('X');
                imageW = arr2[0];
                imageH = arr2[1];
            } else {
                imageW = 500;
                imageH = 500;
            }

            let isHorizontal = parseInt(imageW)  < parseInt(imageH);

            let heightScala = 285 / 345;
            if (isHorizontal) {
                heightScala = 1;
            }


            return <div style={{marginLeft: -15}} onClick={() => this._onImagePress(0)}>
                <Vertical style={{
                    width: feedImgLen1,
                    height: feedImgLen1 * heightScala,
                    borderRadius: 4,
                    marginLeft: pageMargin,
                    overflow: 'hidden',
                    backgroundColor: '#ccc'
                }}>
                    <Image source={{uri: images[0]}}
                              style={{
                                  width: feedImgLen1,
                                  height: feedImgLen1 * heightScala,
                              }}/>
                </Vertical>
            </div>
        } else if (images.length == 2){
            return <Horizontal style={{marginLeft: -15}}>
                <div onClick={() => this._onImagePress(0)}>
                    <Vertical style={{
                        width: feedImgLen2,
                        height: feedImgLen2,
                        borderRadius: 4,
                        marginLeft: pageMargin,
                        overflow: 'hidden',
                        backgroundColor: '#ccc'
                    }}>
                        <Image source={{uri: images[0]}}
                                  style={{
                                      width: feedImgLen2,
                                      height: feedImgLen2,
                                  }}/>
                    </Vertical>
                </div>
                <div onClick={() => this._onImagePress(1)}>
                    <Vertical style={{
                        width: feedImgLen2,
                        height: feedImgLen2,
                        borderRadius: 4,
                        marginLeft: feedImgDivider,
                        overflow: 'hidden',
                        backgroundColor: '#ccc'
                    }}>
                        <Image source={{uri: images[1]}}
                                  style={{
                                      width: feedImgLen2,
                                      height: feedImgLen2,
                                  }}/>
                    </Vertical>
                </div>
            </Horizontal>;
        } else if (images.length == 3){
            let url = images[0];
            let arr1 = url.split('_W_');

            let imageW;
            let imageH;

            if (arr1.length === 2) {
                let arr2 = arr1[1].split('X');
                imageW = arr2[0];
                imageH = arr2[1];
            } else {
                imageW = 500;
                imageH = 500;
            }

            let isHorizontal = parseInt(imageW)  < parseInt(imageH);

            return <Vertical style={isHorizontal ? {flexDirection: 'row'} : {marginLeft: -15}}>
                <div onClick={() => this._onImagePress(0)}>
                    <Vertical style={{
                        width: !isHorizontal ? feedImgLen1 : feedImgLen2,
                        height: !isHorizontal ? feedImgLen1 * 190 / 345 : feedImgLen1,
                        borderRadius: 4,
                        marginLeft: pageMargin,
                        overflow: 'hidden',
                        backgroundColor: '#ccc'
                    }}>
                        <Image source={{uri: images[0]}}
                                  style={{
                                      width: !isHorizontal ? feedImgLen1 : feedImgLen2,
                                      height: !isHorizontal ? feedImgLen1 * 190 / 345 : feedImgLen1,
                                  }}/>
                    </Vertical>
                </div>
                <Vertical style={!isHorizontal ? {flexDirection: 'row', marginTop: feedImgDivider} : {}}>
                    <div onClick={() => this._onImagePress(1)}>
                        <Vertical style={{
                            width: feedImgLen2,
                            height: feedImgLen2,
                            borderRadius: 4,
                            marginLeft: !isHorizontal ? pageMargin : feedImgDivider,
                            overflow: 'hidden',
                            backgroundColor: '#ccc'
                        }}>
                            <Image source={{uri: images[1]}}
                                      style={{
                                          width: feedImgLen2,
                                          height: feedImgLen2,
                                      }}/>
                        </Vertical>
                    </div>
                    <div onClick={() => this._onImagePress(2)}>
                        <Vertical style={{
                            width: feedImgLen2,
                            height: feedImgLen2,
                            borderRadius: 4,
                            marginLeft: feedImgDivider,
                            overflow: 'hidden',
                            marginTop: !isHorizontal ? 0 : feedImgDivider,
                            backgroundColor: '#ccc'
                        }}>
                            <Image source={{uri: images[2]}}
                                      style={{
                                          width: feedImgLen2,
                                          height: feedImgLen2,
                                      }}/>
                        </Vertical>
                    </div>
                </Vertical>
            </Vertical>;
        } else {
            let url = images[0];
            let arr1 = url.split('_W_');

            let imageW;
            let imageH;

            if (arr1.length === 2) {
                let arr2 = arr1[1].split('X');
                imageW = arr2[0];
                imageH = arr2[1];
            } else {
                imageW = 500;
                imageH = 500;
            }


            if (imageW === imageH) {
                return <Vertical style={{marginLeft: -15}}>
                    <Horizontal>
                        <div onClick={() => this._onImagePress(0)}>
                            <Vertical style={{
                                width: feedImgLen2,
                                height: feedImgLen2,
                                borderRadius: 4,
                                marginLeft: pageMargin,
                                overflow: 'hidden',
                                backgroundColor: '#ccc'
                            }}>
                                <Image source={{uri: images[0]}}
                                          style={{
                                              width: feedImgLen2,
                                              height: feedImgLen2,
                                          }}/>
                            </Vertical>
                        </div>
                        <div onClick={() => this._onImagePress(1)}>
                            <Vertical style={{
                                width: feedImgLen2,
                                height: feedImgLen2,
                                borderRadius: 4,
                                marginLeft: feedImgDivider,
                                overflow: 'hidden',
                                backgroundColor: '#ccc'
                            }}>
                                <Image source={{uri: images[1]}}
                                          style={{
                                              width: feedImgLen2,
                                              height: feedImgLen2,
                                          }}/>
                            </Vertical>
                        </div>
                    </Horizontal>
                    <Horizontal style={{marginTop: feedImgDivider}}>
                        <div onClick={() => this._onImagePress(2)}>
                            <Vertical style={{
                                width: feedImgLen2,
                                height: feedImgLen2,
                                borderRadius: 4,
                                marginLeft: pageMargin,
                                overflow: 'hidden',
                                backgroundColor: '#ccc'
                            }}>
                                <Image source={{uri: images[2]}}
                                          style={{
                                              width: feedImgLen2,
                                              height: feedImgLen2,
                                          }}/>
                            </Vertical>
                        </div>
                        <div onClick={() => this._onImagePress(3)}>
                            <Vertical style={{
                                position: 'relative',
                                width: feedImgLen2,
                                height: feedImgLen2,
                                borderRadius: 4,
                                marginLeft: feedImgDivider,
                                overflow: 'hidden',
                                backgroundColor: '#ccc'
                            }}>
                                <Image source={{uri: images[3]}}
                                          style={{
                                              width: feedImgLen2,
                                              height: feedImgLen2,
                                          }}/>
                                {images.length > 4 && <Horizontal style={styles.cover}>
                                    <Text style={styles.addText}>+</Text>
                                    <Text style={styles.numText}>{images.length - 4}</Text>
                                </Horizontal>}
                            </Vertical>
                        </div>
                    </Horizontal>
                </Vertical>
            }

            let isHorizontal = parseInt(imageW)  < parseInt(imageH);
            // let isHorizontal = imageW < imageH;

            return <Vertical style={isHorizontal ? {flexDirection: 'row', marginLeft: -15} : {marginLeft: -15}}>
                <div onClick={() => this._onImagePress(0)}>
                    <Vertical style={{
                        width: !isHorizontal ? feedImgLen1 : feedImgLen4,
                        height: !isHorizontal ? feedImgLen4 : feedImgLen1,
                        borderRadius: 4,
                        marginLeft: pageMargin,
                        overflow: 'hidden',
                        backgroundColor: '#ccc'
                    }}>
                        <Image source={{uri: images[0]}}
                                  style={{
                                      width: !isHorizontal ? feedImgLen1 : feedImgLen4,
                                      height: !isHorizontal ? feedImgLen4 : feedImgLen1,
                                  }}/>
                    </Vertical>
                </div>
                <Vertical style={!isHorizontal ? {flexDirection: 'row', marginTop: feedImgDivider} : {}}>
                    <div onClick={() => this._onImagePress(1)}>
                        <Vertical style={{
                            width: feedImgLen3,
                            height: feedImgLen3,
                            borderRadius: 4,
                            marginLeft: !isHorizontal ? pageMargin : feedImgDivider,
                            overflow: 'hidden',
                            backgroundColor: '#ccc'
                        }}>
                            <Image source={{uri: images[1]}}
                                      style={{
                                          width: feedImgLen3,
                                          height: feedImgLen3,
                                      }}/>
                        </Vertical>
                    </div>
                    <div onClick={() => this._onImagePress(2)}>
                        <Vertical style={{
                            width: feedImgLen3,
                            height: feedImgLen3,
                            borderRadius: 4,
                            marginLeft: feedImgDivider,
                            overflow: 'hidden',
                            marginTop: !isHorizontal ? 0 : feedImgDivider,
                            backgroundColor: '#ccc'
                        }}>
                            <Image source={{uri: images[2]}}
                                      style={{
                                          width: feedImgLen3,
                                          height: feedImgLen3,
                                      }}/>
                        </Vertical>
                    </div>
                    <div onClick={() => this._onImagePress(3)}>
                        <Vertical style={{
                            position: 'relative',
                            width: feedImgLen3,
                            height: feedImgLen3,
                            borderRadius: 4,
                            marginLeft: feedImgDivider,
                            overflow: 'hidden',
                            marginTop: !isHorizontal ? 0 : feedImgDivider,
                            backgroundColor: '#ccc'
                        }}>
                            <Image source={{uri: images[3]}}
                                      style={{
                                          width: feedImgLen3,
                                          height: feedImgLen3,
                                      }}/>
                            {images.length > 4 && <Horizontal style={styles.cover}>
                                <Text style={styles.addText}>+</Text>
                                <Text style={styles.numText}>{images.length - 4}</Text>
                            </Horizontal>}
                        </Vertical>
                    </div>
                </Vertical>
            </Vertical>;
        }

    }
}

const styles = {
    Image: {
        backgroundColor: '#f0f0f0',
        // flex: 1,
        // width: '100%',
        // height: '100%',
    },

    cover: {
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },

    addText: {
        fontSize: 32,
        color: '#fff',
        fontWeight: '200'
    },

    numText: {
        fontSize: 43,
        color: '#fff',
    }
}


// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/ImagesGrid.js